import { render } from "./label_printer.vue?vue&type=template&id=57650076"
import script from "./label_printer.vue?vue&type=script&lang=js"
export * from "./label_printer.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__